import Header from "./header";
import Footer from "./footer";
import { Fragment } from "react";

export default function Layout({ children }) {
  return (
    <Fragment>
      <Header />
      <main className="min-h-[400px]">{children}</main>
      <Footer />
    </Fragment>
  );
}
